import React from 'react';
export function Footer() {
  return <footer className="bg-[#0d0d0d] py-6 px-5 text-center border-t border-[rgba(201,149,108,0.2)]" data-id="element-65">
      <div className="font-playfair text-[20px] text-dorado mb-2" data-id="element-66">
        💎 EFECTO DIAMANTE
      </div>
      <p className="text-[12px] text-[#666] mb-1" data-id="element-67">
        © 2026 Efecto Diamante — Todos los derechos reservados
      </p>
      <p className="text-[12px] text-[#666] mb-1" data-id="element-68">
        Este sitio no es parte de Facebook™ ni de Meta Inc.
      </p>
      <p className="mt-2 text-[11px] text-[#444]" data-id="element-69">
        Los resultados pueden variar según el esfuerzo y dedicación de cada
        persona.
      </p>
    </footer>;
}